/**
 * Pure helpers for compile workflow status transitions on the product surface
 * (docs/optimization/COMPILED-WORKFLOW-SURFACE-PRD.md A8).
 *
 * Resume MUST restore the status captured at pause time — never derive from
 * lastEpoch (a compiling workflow with epochs would wrongly flip to compiled
 * and break autorun eligibility).
 */

export type CompilationStatus =
  | "defined"
  | "sourcing"
  | "compiling"
  | "compiled"
  | "paused";

/**
 * Status to write on resume. `statusBeforePause` is the value captured when
 * the operator hit Pause. If missing (page loaded already paused), fall back
 * to `compiling` — never lastEpoch-based inference.
 */
export function resumeStatusAfterPause(
  statusBeforePause: CompilationStatus | null | undefined,
): Exclude<CompilationStatus, "paused"> {
  if (statusBeforePause && statusBeforePause !== "paused") {
    return statusBeforePause;
  }
  return "compiling";
}
